define('shared/initializer/form/adapters/mixins/upsell/CardPayment',[
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/util/state/adapters/persistent',
    'shared/util/state/adapters/order',
    'shared/util/checkout/checkout',
    'shared/initializer/form/constants',
    '../Returnable'
], 
function (
    RSVP,
    state,
    persistentAdapter,
    orderAdapter,
    checkoutUtil,
    constants,
    Returnable
) {
    'use strict';

    function pageLoad() {
        var me = this;
        var upsellInfo;

        return RSVP.resolve()
            .then(function(){
                state.adapters.add(persistentAdapter);
            })
            .then(function(){
                return state.get('persistent.upsell');
            })
            .then(function(values){
                upsellInfo = values[0] && values[0].value;
            })
            .then(function() {
                if (
                    upsellInfo == null ||
                    upsellInfo.selectedOffers == null ||
                    upsellInfo.selectedOffers.length <= 0
                ) {
                    return;
                }

                me.$form.attr(Returnable.URL_CARD_NEW, me.$form.attr(Ctor.URL_CARD_NEW));
                me.$form.attr(Returnable.URL_CARD_EXISTING, me.$form.attr(Ctor.URL_CARD_EXISTING));
            });
    }

    function retrievingOffer() {
        var upsellInfo;

        return state.adapters.add(orderAdapter)
            .then(function(){
                return state.adapters.add(persistentAdapter);
            })
            .then(function(){
                return state.get('persistent.upsell');
            })
            .then(function(values){
                upsellInfo = values[0] && values[0].value;
                return RSVP.resolve(upsellInfo.selectedOffers);
            });
    }

    function Ctor() { }

    Ctor.URL_CARD_EXISTING = 'data-action-upsell-using-existing-card';
    Ctor.URL_CARD_NEW = 'data-action-upsell-using-new-card';

    Ctor.prototype.doPageLoad = function() {
        var me = this;
        var flowType;
        
        return checkoutUtil.getCurrentFlowType()
            .then(function(ft){
                flowType = ft;
                if (flowType !== constants.CheckoutFlowType.Upsell) {
                    return RSVP.resolve();
                }
                else {
                    pageLoad.call(me);
                }
            });
    };

    Ctor.prototype.doBeforeRetrievingOffersForSubmission = function() {
        var me = this;
        var flowType;
        
        return checkoutUtil.getCurrentFlowType()
            .then(function(ft){
                flowType = ft;
                if (flowType !== constants.CheckoutFlowType.Upsell) {
                    return RSVP.resolve();
                }
                else {
                    return retrievingOffer.call(me);
                }
            });
    };

    return Ctor;
});
